export default __webpack_public_path__ + "static/media/black-menu.cefdb09a.svg";